import { h as head, e as escape_html, c as attr_class, b as attr, f as clsx, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { e as eyeSlash } from "../../../../chunks/icons.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
import "../../../../chunks/validationSchemas.js";
import { h as html } from "../../../../chunks/html.js";
function _page($$payload, $$props) {
  push();
  const SITE_KEY = "6LfFwpkUAAAAAP5ziCkmMum9c8L_naD_F085nHq0";
  const { form } = $$props;
  let name = form?.data?.name;
  let email = form?.data?.email;
  let phoneNumber = form?.data?.phoneNumber;
  let idNumber = form?.data?.idNumber;
  let password = "";
  let confirmPassword = "";
  let address = form?.data?.address;
  let postalCode = form?.data?.postalCode;
  let formErrors = form?.errors || {};
  getToastState();
  const getFieldError = (field) => {
    return formErrors[field]?.[0] || "";
  };
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Register</title>`;
    $$payload2.out.push(`<script src="https://www.google.com/recaptcha/api.js" async defer><\/script><!---->`);
  });
  $$payload.out.push(`<h2 class="text-center text-2xl font-bold">Welcome, Please Register</h2> <div class="text-primary mt-3 text-xs"><span class="hover:underline"><a href="/login">Back to login</a></span></div> <form class="mt-4 space-y-3" method="POST" action="" autocomplete="on">`);
  if (formErrors._errors) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="mb-4 rounded-md bg-red-50 p-4" role="alert"><p class="text-sm text-red-700">${escape_html(formErrors._errors[0])}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div><label for="email" class="block text-sm font-semibold">Full Name <span class="text-red-500">*</span></label> <input type="text" id="name" name="name" autocomplete="name"${attr_class(
    clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!getFieldError("name")
    }),
    "svelte-m1xxe0"
  )}${attr("value", name)}${attr("aria-invalid", !!getFieldError("name"))}${attr("aria-describedby", getFieldError("name") ? "name-error" : void 0)} required/> `);
  if (getFieldError("name")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="name-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("name"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="flex gap-3"><div class="flex-1"><label class="block text-sm font-semibold">ID Number <span class="text-red-500">*</span></label> <input type="number" id="idNumber" name="idNumber"${attr("value", idNumber)} class="focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none svelte-m1xxe0" required/> `);
  if (getFieldError("idNumber")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("idNumber"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="flex-1"><label class="block text-sm font-semibold">Phone Number <span class="text-red-500">*</span></label> <input type="tel" id="phoneNumber" name="phoneNumber"${attr("value", phoneNumber)} class="focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none svelte-m1xxe0" placeholder="07..." required/> `);
  if (getFieldError("phoneNumber")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("phoneNumber"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div> <div><label for="email" class="block text-sm font-semibold">Email <span class="text-red-500">*</span></label> <input type="email" id="email" name="email" autocomplete="username"${attr_class(
    clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!getFieldError("email")
    }),
    "svelte-m1xxe0"
  )}${attr("value", email)}${attr("aria-invalid", !!getFieldError("email"))}${attr("aria-describedby", getFieldError("email") ? "email-error" : void 0)} required/> `);
  if (getFieldError("email")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="email-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("email"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="flex gap-3"><div class="flex-1"><label class="block text-sm font-semibold">Address <span class="text-red-500">*</span></label> <input type="text" id="address" name="address"${attr("value", address)} class="focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none svelte-m1xxe0" required/> `);
  if (getFieldError("address")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("address"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="flex-1"><label class="block text-sm font-semibold">Postal Code <span class="text-red-500">*</span></label> <input type="text" id="postalCode" name="postalCode"${attr("value", postalCode)} class="focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none svelte-m1xxe0" required/> `);
  if (getFieldError("postalCode")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(getFieldError("postalCode"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></div> <div class="group relative"><label for="password" class="block text-sm font-semibold">Password <span class="text-red-500">*</span></label> <input${attr("type", "password")} id="password" name="password" autocomplete="new-password"${attr_class(
    clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!getFieldError("password")
    }),
    "svelte-m1xxe0"
  )}${attr("value", password)}${attr("aria-invalid", !!getFieldError("password"))}${attr("aria-describedby", getFieldError("password") ? "password-error" : void 0)} required/> `);
  if (getFieldError("password")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="password-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("password"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <button type="button" class="text-gray-7 00 absolute top-7 right-3 text-xs" tabindex="-1">`);
  {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`${html(eyeSlash)}`);
  }
  $$payload.out.push(`<!--]--></button></div> <div class="group relative"><label for="confirmPassword" class="block text-sm font-semibold">Confirm Password <span class="text-red-500">*</span></label> <input${attr("type", "password")} id="confirmPassword" name="confirmPassword"${attr_class(
    clsx({
      "focus:border-primary focus:outline-nonex w-full rounded-md border-2 border-black p-2	": true,
      "border-red-500": !!getFieldError("confirmPassword")
    }),
    "svelte-m1xxe0"
  )}${attr("value", confirmPassword)}${attr("aria-invalid", !!getFieldError("confirmPassword"))}${attr("aria-describedby", getFieldError("confirmPassword") ? "confirmPassword-error" : void 0)} required/> `);
  if (getFieldError("confirmPassword")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="confirmPassword-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("confirmPassword"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <button type="button" class="absolute top-7 right-3 text-xs text-gray-700" tabindex="-1">`);
  {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`${html(eyeSlash)}`);
  }
  $$payload.out.push(`<!--]--></button></div> `);
  if (formErrors["g-recaptcha-response"]) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="text-sm text-red-600">${escape_html(formErrors["g-recaptcha-response"])}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="g-recaptcha"${attr("data-sitekey", SITE_KEY)}></div> <button type="submit" class="group bg-primary hover:bg-primary/90 flex w-full cursor-pointer items-center justify-center rounded-md border p-2 text-white transition-colors">`);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> Register</button></form> <div class="mt-2"><a href="/verify" class="text-primary text-xs transition-colors hover:underline">Resend Verification Email</a></div>`);
  pop();
}
export {
  _page as default
};
